<template>
  <div class="my-certificates-layout">
    <h2 class="my-certificates-headline" v-if="showHeadline">
      <b>{{ $t('VMX.certificate_list_headline') }}</b>
    </h2>
    <div v-if="certArray" class="my-certificate-container">
      <div
        v-for="(item, idx) in certArray"
        :key="idx"
      >
        <a @click="downloadCertificate(item.Url)">
        <i class="fas fa-download" /> {{ item.FileName }}
      </a>
      </div>
    </div>
  </div>
</template>
<script>
import certificates from '~/api/certificates'
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      certArray: null,
    }
  },
  async mounted() {
    this.certArray = await certificates.getCertificate()
  },
  methods: {
    downloadCertificate(myCertUrl) {
      if (this.isAppContainer) {
        const message = 'pdf-download'
        const messageObj = {
          message,
          content: myCertUrl,
        }
        const stringifiedMessageObj = JSON.stringify(messageObj)
        if (window.webkit && window.webkit.messageHandlers) {
          window.webkit.messageHandlers.cordova_iab.postMessage(
            stringifiedMessageObj,
          )
        }
        //window.location.assign(`${this.appConfigV2.defaultV2.abstractS3Url}${encodeURIComponent(this.abstract.PdfFileUrl)}`)
      } else {
        window.open(myCertUrl, '_blank')
      }
    }
  },
  computed: {
    ...mapGetters({
      isAppContainer: 'instancesState/getIsAppContainer',
    }),
    showHeadline() {
      return !!this.certArray
    },
  },
}
</script>

<style lang="scss">
.my-certificates-layout {
  .my-certificates-headline {
      margin-bottom: 1rem;
    }
  .my-certificate-container {
    padding: 0 20px;
    background-color: #fff;
    position: relative;
    box-shadow: 0 0 10px 0 #ccc;
    a {
        color: var(--primary-industry);
        cursor: pointer;
      }

    /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */
    .my-certificates-text {
      padding: 10px 0;

      

      .cert-date {
        @media (min-width: 577px) {
          text-align: right;
        }
      }
    }

    .my-certificates-text:first-child {
      padding-top: 20px;
    }

    .my-certificates-text:last-child {
      padding-bottom: 20px;
    }
  }
}</style>
